import { api } from "../helpers";

export const migrate_from_shop_to_toshop = async (data: any) => {
  let res = await api.post(`/migration/migrate_from_shop_to_toshop`, data)
    .catch((error) => {
      return error;
    });
  return res;
};
export const clean_shop_record = async (data: any) => {
  let res = await api.post(`/migration/clean_shop`, data)
    .catch((error) => {
      return error;
    });
  return res;
};
export const hard_delete_shop_record = async (data: any) => {
  let res = await api.post(`/admin/shop/harddeleteshop`, data)
    .catch((error) => {
      return error;
    });
  return res;
};
export const sync_shop_record = async (data: any) => {
  let res = await api.post(`/admin/shop/sync`, data)
    .catch((error) => {
      return error;
    });
  return res;
};
